import Vue from "vue";
const vm = new Vue();

const API_BANNER = vm.$API_URL + `/banner-api`;

export const getBanner = async (bannerCampaignPosition) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(API_BANNER, {
        params: {
          device: screen.width > 900 ? "desktop" : "mobile",
          position_page: bannerCampaignPosition,
        },
      })
      .then((res) => {
        if (res.data && res.data.result) {
          resolve(res.data.result);
        } else {
          reject("ไม่มีข้อมูล");
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            reject(error.response.data);
          }
        }
        reject(error);
      });
  });
};
